/* eslint-disable operator-linebreak */
import { FC, useEffect } from 'react';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Slug } from '../../types';

export const Settings: FC = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    params: { refId },
  } = useRouteMatch<Slug>();

  const tabs = [
    { name: 'Hospital Settings', path: `/${refId}/settings/hospital` },
    { name: 'Prime Time', path: `/${refId}/settings/prime_time` },
  ];

  useEffect(() => {
    if (location.pathname === `/${refId}/settings`) {
      history.replace(`/${refId}/settings/hospital`);
    }
  }, [location.pathname, refId, history]);

  const isActiveTab = (path: string) => location.pathname === path;

  return (
    <div className="w-full mx-auto">
      <div className="border-b border-gray-200">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => history.push(tab.path)}
              className={`
                py-4 px-1 text-center border-b-2 font-medium text-2xl transition-colors duration-300
                ${
                  isActiveTab(tab.path)
                    ? 'border-blue text-blue font-bold'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-y-indigo-200 font-bold'
                }
              `}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};
